import React from "react";
import { Grid } from "react-bootstrap";
import { IZLoginModule } from "../../../../../../modules/zcommon/contracts";
import { OpcionPreferido } from "../../../../../models/opciones-preferidas/OpcionPreferido";
import ItemPreferido from "../item-preferidos/ItemPreferido.comp";
import "./lista-preferidos.style.css";

type ListaPreferidasProps = {
  listaPreferidos: OpcionPreferido[] | undefined;
  zLoginModule: IZLoginModule;
};

const ListaPreferidos: React.FC<ListaPreferidasProps> = (props) => {
  if (props.listaPreferidos === undefined) {
    return (
      <div className="lista-vacia">
        <h3 className="sidebar-section-title">Opciones preferidas</h3>
        <h4 className="fuente-h4">No hay opciones preferidas</h4>
      </div>
    );
  } else {
    return (
      <div>
        <h4 className="sidebar-section-title">Opciones preferidas</h4>
        <Grid className="grid-preferidos">
          {props.listaPreferidos.map((opcionPreferida) => {
            return (
              <ItemPreferido
                key={opcionPreferida.opc}
                preferido={opcionPreferida}
                zLoginModule={props.zLoginModule}
              />
            );
          })}
        </Grid>
      </div>
    );
  }
};
export default ListaPreferidos;



// WEBPACK FOOTER //
// ./src/portal/components/sidebar/components/preferidos/lista-preferidos/ListaPreferidos.comp.tsx